import React, { useEffect, useRef, useState } from 'react'
import project from '../../project.js'
import { MedalTally } from './MedalTally'
import { Schedule } from './Schedule'
import { AussiesSchedule } from './AussiesSchedule'
import { Winners } from './Winners'
import { Tracking } from '../utils/tracking.js'
import '../assets/styles/home.scss'

const TABS = [
  { id: 'medals', label: 'Medals', component: MedalTally },
  { id: 'schedule', label: 'Schedule', component: Schedule },
  { id: 'aussies', label: 'Aussies', component: AussiesSchedule },
  { id: 'winners', label: 'Winners', component: Winners }
]

function Home({ mode = 'multi', initialTab = 'medals', noHeightLimit = false }) {
  const [activeTab, setActiveTab] = useState(initialTab)
  const firstInteractionRef = useRef(false)
  const appRef = useRef(null)

  const currentTab = TABS.find(tab => tab.id === activeTab)
  const CurrentComponent = currentTab?.component
  const isSingleMode = mode === 'single'
  const singleModeTitle =
    currentTab?.id === 'winners'
      ? 'Medal Winners'
      : currentTab?.id === 'aussies'
        ? 'Aussies in Action'
        : currentTab?.label

  useEffect(() => {
    const appContainer = document.getElementById(`app_${project.name}`)
    const fallbackContainer =
      appRef.current?.closest('div[data-commgames-mounted="1"], div[id^="app_"]') ||
      appRef.current
    const trackingTarget = appContainer || fallbackContainer

    if (!trackingTarget) return undefined

    const handleFirstInteraction = () => {
      if (firstInteractionRef.current) return
      firstInteractionRef.current = true
      Tracking.trackPageImpression('firstinteraction', project.name)
    }

    trackingTarget.addEventListener('mouseenter', handleFirstInteraction)

    return () => {
      trackingTarget.removeEventListener('mouseenter', handleFirstInteraction)
    }
  }, [])

  return (
    <div ref={appRef} className={`nnd-app nnd-app--${mode}${noHeightLimit ? ' nnd-app--no-height-limit' : ''}`}>
      <div className={`nnd-container${noHeightLimit ? ' nnd-container--no-height-limit' : ''}`}>
        <div className="nnd-header">
          <h1 className="nnd-title">Commonwealth Games 2026</h1>
        </div>

        {!isSingleMode && (
          <div className="tabs-navigation">
            {TABS.map(tab => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
                aria-selected={activeTab === tab.id}
                role="tab"
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        {isSingleMode && (
          <div className="single-mode-header">
            <h2 className="single-mode-title">{singleModeTitle}</h2>
          </div>
        )}

        <div className="tabs-content">
          {CurrentComponent && (
            <CurrentComponent isActive={activeTab === currentTab.id} noHeightLimit={noHeightLimit} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Home
